export default __webpack_public_path__ + "static/media/07_photo.cc29c0f5.jpg";